import { render } from "./AssetDetail.vue?vue&type=template&id=1f8901de"
import script from "./AssetDetail.vue?vue&type=script&lang=js"
export * from "./AssetDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__